import { render, staticRenderFns } from "./wtr-educational-material-list.vue?vue&type=template&id=0b259f14&scoped=true&"
import script from "./wtr-educational-material-list.vue?vue&type=script&lang=js&"
export * from "./wtr-educational-material-list.vue?vue&type=script&lang=js&"
import style0 from "./wtr-educational-material-list.vue?vue&type=style&index=0&id=0b259f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b259f14",
  null
  
)

export default component.exports